var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCustoms(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_355_4730)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 1,
    width: 48,
    height: 48,
    rx: 10,
    fill: "white",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 1.5,
    width: 47,
    height: 47,
    rx: 9.5,
    stroke: "#EAECF0",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26 35.75C20.07 35.75 15.25 30.93 15.25 25C15.25 23.12 15.74 21.27 16.68 19.64C16.89 19.28 17.34 19.16 17.7 19.36L26.37 24.34C26.73 24.55 26.85 25 26.65 25.36C26.44 25.72 25.99 25.84 25.63 25.64L17.63 21.05C17.05 22.28 16.75 23.62 16.75 24.99C16.75 30.09 20.9 34.24 26 34.24C31.1 34.24 35.25 30.09 35.25 24.99C35.25 19.89 31.1 15.74 26 15.74C23.98 15.74 22.06 16.38 20.45 17.59C20.12 17.84 19.65 17.77 19.4 17.44C19.15 17.11 19.22 16.64 19.55 16.39C21.42 14.99 23.65 14.24 26 14.24C31.93 14.24 36.75 19.06 36.75 24.99C36.75 30.92 31.93 35.75 26 35.75Z",
    fill: "#292D32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26 31.75C22.28 31.75 19.25 28.72 19.25 25C19.25 23.8 19.57 22.61 20.18 21.58C20.39 21.22 20.85 21.1 21.21 21.31C21.57 21.52 21.69 21.98 21.48 22.34C21.01 23.14 20.76 24.06 20.76 25C20.76 27.9 23.12 30.25 26.01 30.25C28.9 30.25 31.26 27.9 31.26 25C31.26 22.1 28.9 19.75 26.01 19.75C25.23 19.75 24.48 19.92 23.77 20.25C23.39 20.42 22.95 20.26 22.77 19.89C22.59 19.51 22.75 19.07 23.13 18.89C24.03 18.47 25 18.25 26 18.25C29.72 18.25 32.75 21.28 32.75 25C32.75 28.72 29.72 31.75 26 31.75Z",
    fill: "#292D32"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_355_4730",
    x: 0,
    y: 0,
    width: 52,
    height: 52,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_355_4730"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_355_4730",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustoms);
export default __webpack_public_path__ + "static/media/customs.750e9e5f6d98c7adbd01026078d9d102.svg";
export { ForwardRef as ReactComponent };